import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\GetElectronicSignatureByIdController::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetElectronicSignatureByIdController.php
* @route '/api/electronic-signature/{electronicSignature}'
*/
const GetElectronicSignatureByIdController = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetElectronicSignatureByIdController.url(args, options),
    method: 'get',
})

GetElectronicSignatureByIdController.definition = {
    methods: ["get","head"],
    url: '/api/electronic-signature/{electronicSignature}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\GetElectronicSignatureByIdController::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetElectronicSignatureByIdController.php
* @route '/api/electronic-signature/{electronicSignature}'
*/
GetElectronicSignatureByIdController.url = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { electronicSignature: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { electronicSignature: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
    }

    return GetElectronicSignatureByIdController.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\GetElectronicSignatureByIdController::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetElectronicSignatureByIdController.php
* @route '/api/electronic-signature/{electronicSignature}'
*/
GetElectronicSignatureByIdController.get = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetElectronicSignatureByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ElectronicSignature\GetElectronicSignatureByIdController::__invoke
* @see app/Http/Controllers/ElectronicSignature/GetElectronicSignatureByIdController.php
* @route '/api/electronic-signature/{electronicSignature}'
*/
GetElectronicSignatureByIdController.head = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetElectronicSignatureByIdController.url(args, options),
    method: 'head',
})

export default GetElectronicSignatureByIdController